// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ButtonsPreview--next-sr-only--C_2__nG","btnsContainer":"ButtonsPreview--btnsContainer--1mi6ZB2"};